import { getAvailableMetrics } from "../../../helpers"

const availableMetrics = getAvailableMetrics()

const MetricRecordFormMixin = {
	methods: {
		formatMetrics(metrics) {
			return metrics.map(metric => ({
				metric_id: metric.id,
				value: metric.value,
			}))			
        },
		getDefaultMetrics() {
			return availableMetrics.map(metric => ({
				...metric,
				value: null,
			}))			
        },
		parseServerMetrics(metrics) {
			return metrics.map(({ pivot, ...metric }) => ({
				...metric,
				value: _.get(pivot, 'value', null),
			}))			
        },
	}
}

export default MetricRecordFormMixin
